import * as Commands from './commands';
import {Injectable} from '@angular/core';
import {StageService} from '../stage.service';
import {RailingGenerationService} from '../railing/services/railing-generation.service';
import {ObjectTransformationFactory} from './common/ObjectTransformation';
import {DeleteObjectService} from '../delete-object.service';
import {SetMaterialsService} from '../set-materials.service';
import {BuildFloorService} from '../build-floor.service';
import {WallBuilderService} from '../wall/wall-builder.service';
import {DeckHeightService} from '../deck-height.service';

type CommandType = new (...args) => Commands.Command<any>;


@Injectable()
export class CommandFactory {

  constructor(
    private StageSrvc: StageService,
    private railingGenerationService: RailingGenerationService,
    private objectTransformationFactory: ObjectTransformationFactory,
    private deleteObjectSrvc: DeleteObjectService,
    private materialSrvc: SetMaterialsService,
    private buildFloorSrvc: BuildFloorService,
    private wallBuilder: WallBuilderService,
    private deckHeightSrvc: DeckHeightService
  ) {
  }

  create(commandType: CommandType): Commands.Command<any> {
    let result;

    switch (commandType) {
      case Commands.ObjectDeleteCommand:
        result = new Commands.ObjectDeleteCommand(this.StageSrvc);
        break;
      case Commands.DeleteWallCommand:
        result = new Commands.DeleteWallCommand(this.StageSrvc, this.railingGenerationService);
        break;
      case Commands.SaveObjectsTransformCommand:
        result = new Commands.SaveObjectsTransformCommand(this.objectTransformationFactory);
        break;
      case Commands.AddObjectCommand:
        result = new Commands.AddObjectCommand(this.StageSrvc);
        break;
      case Commands.AddTierCommand:
        result = new Commands.AddTierCommand(this.deleteObjectSrvc);
        break;
      case Commands.AddStairsCommand:
        result = new Commands.AddStairsCommand(this.deleteObjectSrvc, this.StageSrvc);
        break;
      case Commands.ChangeMaterialCommand:
        result = new Commands.ChangeMaterialCommand(this.materialSrvc);
        break;
      case Commands.EditFloorShapeCommand:
        result = new Commands.EditFloorShapeCommand(this.railingGenerationService, this.buildFloorSrvc, this.StageSrvc);
        break;
      case Commands.AddWallCommand:
        result = new Commands.AddWallCommand(this.StageSrvc, this.railingGenerationService);
        break;
      case Commands.ChangeWallSizeCommand:
        result = new Commands.ChangeWallSizeCommand(this.wallBuilder);
        break;
      case Commands.ChangeStairsTransformationCommand:
        result = new Commands.ChangeStairsTransformationCommand(this.railingGenerationService, this.StageSrvc);
        break;
      case Commands.ResizeTierCommand:
        result = new Commands.ResizeTierCommand(this.buildFloorSrvc, this.StageSrvc);
        break;
      case Commands.TierStepSizeChangeCommand:
        result = new Commands.TierStepSizeChangeCommand(this.StageSrvc);
        break;
      case Commands.SetHeightCommand:
        result = new Commands.SetHeightCommand(this.deckHeightSrvc);
        break;
      default:
        throw new Error(`cant create command of ${commandType}`);
    }

    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/CommandFactory.ts